/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, AuthBaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { XFoundHttpClient } from '@/core/components/authentication/http/abstractions/xfound.httpclient';

import { PortalzugriffDisplayModel as AceXFoundPortalCoreCaqModelsPortalzugriffDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/portalzugriff-display-model';
import { GlobalEnumsAceXfoundportalobjekt as AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt } from '../models/ace/xFound/Portal/Core/Entities/global-enums-ace-xfoundportalobjekt';

@Injectable({
providedIn: 'root',
})

export class PortalzugriffService extends BaseService {
constructor(
config: ApiConfiguration,
http: HttpClient,
authHttp: XFoundHttpClient
) {
super(config, http, authHttp);
}

  /**
   * Path part for operation apiPortalzugriffAnfrageIdGet
   */
  static readonly ApiPortalzugriffAnfrageIdGetPath = '/api/Portalzugriff/{anfrageId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPortalzugriffAnfrageIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPortalzugriffAnfrageIdGet$Plain$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsPortalzugriffDisplayModel>>> {

    const rb = new RequestBuilder(this.rootUrl, PortalzugriffService.ApiPortalzugriffAnfrageIdGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/plain',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsPortalzugriffDisplayModel>>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPortalzugriffAnfrageIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPortalzugriffAnfrageIdGet$Plain(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<Array<AceXFoundPortalCoreCaqModelsPortalzugriffDisplayModel>> {

    return this.apiPortalzugriffAnfrageIdGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsPortalzugriffDisplayModel>>) => r.body as Array<AceXFoundPortalCoreCaqModelsPortalzugriffDisplayModel>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPortalzugriffAnfrageIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPortalzugriffAnfrageIdGet$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsPortalzugriffDisplayModel>>> {

    const rb = new RequestBuilder(this.rootUrl, PortalzugriffService.ApiPortalzugriffAnfrageIdGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsPortalzugriffDisplayModel>>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPortalzugriffAnfrageIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPortalzugriffAnfrageIdGet(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<Array<AceXFoundPortalCoreCaqModelsPortalzugriffDisplayModel>> {

    return this.apiPortalzugriffAnfrageIdGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsPortalzugriffDisplayModel>>) => r.body as Array<AceXFoundPortalCoreCaqModelsPortalzugriffDisplayModel>)
    );
  }

  /**
   * Path part for operation apiPortalzugriffAnfrageIdPatch
   */
  static readonly ApiPortalzugriffAnfrageIdPatchPath = '/api/Portalzugriff/{anfrageId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPortalzugriffAnfrageIdPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPortalzugriffAnfrageIdPatch$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    body?: Array<AceXFoundPortalCoreCaqModelsPortalzugriffDisplayModel>
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, PortalzugriffService.ApiPortalzugriffAnfrageIdPatchPath, 'patch');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: '*/*',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPortalzugriffAnfrageIdPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPortalzugriffAnfrageIdPatch(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    body?: Array<AceXFoundPortalCoreCaqModelsPortalzugriffDisplayModel>
  }): Observable<void> {

    return this.apiPortalzugriffAnfrageIdPatch$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}